import socialStreamApi from '../social-stream';

/**
 * @async
 * @param {string} streamId
 * @param {string} language
 * @returns {Promise<SocialItemProps[]>}
 */
const fetchSocialStream = async (streamId, language) => {
  const socialStreamPromise = socialStreamApi.get(streamId, language);
  const socialStreamResponse = await socialStreamPromise;
  if (socialStreamResponse.status !== 'OK') {
    throw Error('Got unexpected response');
  }
  const { data } = socialStreamResponse;
  return data.items;
};

export default fetchSocialStream;
